import { AnaColumn } from "../forms-template.service";

export const cer: AnaColumn[] = [
    {
      itemType: "group", colCount: "2", colSpan: "2",
      data: [
         /*{type:'campo', dataField: "gruppo", dataType:"" , caption:"Grss.",groupIndex:0,
          colCaption:'provolino'
        },*/
        {
          type: 'campo', 
          /* disableOnUpdate: true,  ho disabilitato per il momento xke non riuscivo a cercare nella griglia nel filtro sulla colonna*/ 
           mask: "000000", 
           dataField: "id",
           width: "80",
           maxLength: "6",
           dataType: "string",
           caption: "Codice",
          // groupIndex:1,
          orderGriglia:1,
          validation: [
            { type: "stringLength", max: "6", message: "Campo Obbligatorio" },
            { type: "required", message: "Campo Obbligatorio" },
          ],
        },
        { type: 'campo', orderGriglia:2,colWidth: "80", dataField: "pericoloso", dataType: "boolean", caption: "Pericoloso",trueText:'P', falseText:' ', showEditorAlways:false },
      ]
    },
    {
      itemType: "group", colCount: "1", colSpan: "2",
      data: [
        {
          type: 'campo',colWidth:500,  orderGriglia:3,class: "rossa", editorType: "dxTextArea", dataField: "descrizione", colSpan: "2", dataType: "", caption: "Descrizione EER",
          validation: [{ type: "required", message: "Campo Obbligatorio" },],
        }
      ]
    },
    
  ]